import {
  FormHelperText,
  styled,
} from '@mui/material';

export const StyledFormHelperText = styled(FormHelperText)(({ theme, error }) => ({
  fontFamily: 'Lato, sans-serif',
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: '20px',
  color: error ? '#CC0000' : '#666666',
  marginTop: '8px',
  marginLeft: 0,
  marginRight: 0,
  '&.Mui-error':{
    color: '#CC0000',
  },
}));
 